export const gamesData = [
  {
    id: 'president',
    name: 'President',
    nameFr: 'Président',
    image: '/assets/img/mockups/prez.png',
    icon: '/assets/img/icon/prez.png',
    screenshots: [
      '/assets/img/app-screens/prez_01.png'
    ],
    stores: {
      ios: '1437363563',
      android: 'com.summitgames.president'
    }
  },
  {
    id: 'tarot',
    name: 'Tarot',
    nameFr: 'Tarot',
    image: '/assets/img/mockups/tarot.png',
    icon: '/assets/img/icon/tarot.png',
    screenshots: [
      '/assets/img/app-screens/tarot_01.png'
    ],
    stores: {
      ios: '6447291247',
      android: 'com.summitgames.tarot'
    }
  },
  {
    id: 'coinche',
    name: 'Coinche / Contrée',
    nameFr: 'Coinche / Contrée',
    image: '/assets/img/mockups/coinche.png',
    icon: '/assets/img/icon/coinche.png',
    screenshots: [
      '/assets/img/app-screens/coinche_01.png'
    ],
    stores: {
      ios: '1575363906',
      android: 'com.summitgames.coinche'
    }
  },
  {
    id: 'belote',
    name: 'Belote',
    nameFr: 'Belote',
    image: '/assets/img/mockups/belote.png',
    icon: '/assets/img/icon/belote.png',
    screenshots: [
      '/assets/img/app-screens/belote_01.png'
    ],
    stores: {
      ios: '1554144721',
      android: 'com.summitgames.belote'
    }
  },
  {
    id: 'rummy',
    name: 'Rummy',
    nameFr: 'Rami',
    image: '/assets/img/mockups/rummy.png',
    icon: '/assets/img/icon/rummy.png',
    screenshots: [
      '/assets/img/app-screens/rummy_01.png'
    ],
    stores: {
      ios: '1610131571',
      android: 'com.summitgames.rummy'
    }
  },
  {
    id: 'crazy8',
    name: 'Crazy 8',
    nameFr: '8 américain',
    image: '/assets/img/mockups/crazy8.png',
    icon: '/assets/img/icon/crazy8.png',
    screenshots: [
      '/assets/img/app-screens/crazy8_01.jpg'
    ],
    stores: {
      ios: '6741209536',
      android: 'com.summitgames.crazy8'
    }
  },
  {
    id: 'spades',
    name: 'Spades',
    nameFr: 'Spades',
    icon: '/assets/img/icon/spades.png',
    screenshots: [
      '/assets/img/app-screens/spades_01.png'
    ],
    stores: {
      ios: '1545162547',
      android: 'com.summitgames.spades'
    }
  },
  {
    id: 'hearts',
    name: 'Hearts',
    nameFr: 'Dame de pique',
    image: '/assets/img/mockups/hearts.png',
    icon: '/assets/img/icon/hearts.png',
    screenshots: [
      '/assets/img/app-screens/hearts_01.png'
    ],
    stores: {
      ios: '1538482032',
      android: 'com.summitgames.hearts'
    }
  },
  {
    id: 'ginrummy',
    name: 'Gin Rummy',
    nameFr: 'Gin Rummy',
    image: '/assets/img/mockups/ginrummy.png',
    icon: '/assets/img/icon/ginrummy.png',
    screenshots: [
      '/assets/img/app-screens/ginrummy_01.png'
    ],
    stores: {
      ios: '6443807540',
      android: 'com.summitgames.gin'
    }
  },
  {
    id: 'solitaire',
    name: 'Solitaire',
    nameFr: 'Solitaire',
    image: '/assets/img/mockups/sol.png',
    icon: '/assets/img/icon/sol.png',
    screenshots: [
      '/assets/img/app-screens/sol_01.png'
    ],
    stores: {
      ios: '6503046782',
    }
  },
  {
    id: 'spider',
    name: 'Spider',
    nameFr: 'Spider',
    icon: '/assets/img/icon/spider.png',
    screenshots: [
      '/assets/img/app-screens/spider_01.png'
    ],
    stores: {
      ios: '6600849979',
    }
  },
  {
    id: 'freecell',
    name: 'Freecell',
    nameFr: 'Freecell',
    image: '/assets/img/mockups/freecell.png',
    icon: '/assets/img/icon/freecell.png',
    screenshots: [
      '/assets/img/app-screens/freecell_01.png'
    ],
    stores: {
      ios: '6601035762',
    }
  },
  {
    id: 'backgammon',
    name: 'Backgammon',
    nameFr: 'Backgammon',
    image: '/assets/img/mockups/backgammon.png',
    icon: '/assets/img/icon/backgammon.png',
    screenshots: [
      '/assets/img/app-screens/backgammon_01.png'
    ],
    stores: {
      ios: '6744608946',
    }
  },
  {
    id: 'checkers',
    name: 'Checkers',
    nameFr: 'Dames',
    image: '/assets/img/mockups/checkers.png',
    icon: '/assets/img/icon/checkers.png',
    screenshots: [
      '/assets/img/app-screens/checkers_01.png'
    ],
    stores: {
      ios: '6745004174',
    }
  }
];
